module.exports = __webpack_public_path__ + "static/media/blog.a7281bb6.png";